import React from "react";

const Footer = () => (
	<footer className="bg-[#4e4e4e] text-white py-6 text-center mt-10">
		<p className="text-sm">
			&copy; {new Date().getFullYear()} Family Depot Limited. All rights
			reserved.
		</p>
	</footer>
);

export default Footer;
